import { Col, Row } from "react-bootstrap";
import { useState } from "react";
import dayjs from "dayjs";
import { User } from "@/@types/sintegrada/User";
import { PatientsByCidFilters } from "./PatientsByCidFilters";
import { PatientsByCidTable } from "./PatientsByCidTable";

export function PatientsByCid() {
	const [startDate, setStartDate] = useState(dayjs().add(-2, "year").format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
	const [youngerAge, setYoungerAge] = useState<number>();
	const [olderAge, setOlderAge] = useState<number>();
	const [professionalId, setProfessionalId] = useState<number>();
	const [professionals, setProfessionals] = useState<User[]>([]);
	console.log(youngerAge + "" + olderAge + "" + professionalId);
	setProfessionals([]);

	async function fetchDashboard() {
		//setDashboard(await getNonSpecializedMedicalAttendanceDashboard({ uf, ibgeCode, startDate, endDate, youngerAge, olderAge, professionalId }));
	}

	return (
		<>
			<Row className="p-2 mb-10">
				<Col>
					<PatientsByCidFilters
						startDate={startDate}
						setStartDate={setStartDate}
						endDate={endDate}
						setEndDate={setEndDate}
						setYoungerAge={setYoungerAge}
						setOlderAge={setOlderAge}
						setProfessionalId={setProfessionalId}
						professionals={professionals}
						handleFilter={fetchDashboard}
					/>
				</Col>
			</Row>
			<Row className="p-2">
				<Col>
					<PatientsByCidTable />
				</Col>
			</Row>
		</>
	);
}
